import {OrgModalForm} from './OrgModalForm'

const OrgModalFormWrapper = ({setOpenOrgModal, getUser, user}) => {
    return <OrgModalForm setOpenOrgModal={setOpenOrgModal} getUser={getUser} user={user} />
}

export {OrgModalFormWrapper}
